import type {HttpClient} from '@sollapay/http-client';
import type {
  ApiResponse,
  BeneficiaryLastAccountDTO,
  CreatePayoutInstructionPayload,
  CreatePayoutInstructionResponseDTO,
  PayoutInstructionDTO
} from '@sollapay/types';

export const payoutsApi = {
  createPayout: (
    client: HttpClient,
    trustAccountId: string,
    payload: CreatePayoutInstructionPayload,
    stepUpToken: string
  ): Promise<ApiResponse<CreatePayoutInstructionResponseDTO>> =>
    client.post<ApiResponse<CreatePayoutInstructionResponseDTO>, CreatePayoutInstructionPayload>(
      `/trust_accounts/${trustAccountId}/instructions/payouts`,
      payload,
      {headers: {'X-Step-Up-Token': stepUpToken}}
    ),
  fetchPayoutInstructions: (
    client: HttpClient,
    trustAccountId: string
  ): Promise<ApiResponse<PayoutInstructionDTO[]>> =>
    client.get<ApiResponse<PayoutInstructionDTO[]>>(
      `/trust_accounts/${trustAccountId}/instructions/payouts`
    ),
  cancelPayout: (
    client: HttpClient,
    trustAccountId: string,
    payoutInstructionId: string
  ): Promise<ApiResponse<PayoutInstructionDTO>> =>
    client.post<ApiResponse<PayoutInstructionDTO>>(
      `/trust_accounts/${trustAccountId}/instructions/payouts/${payoutInstructionId}/cancel`
    ),
  fetchBeneficiaryLastAccount: (
    client: HttpClient,
    trustAccountId: string,
    partyId: string
  ): Promise<ApiResponse<BeneficiaryLastAccountDTO | null>> =>
    client.get<ApiResponse<BeneficiaryLastAccountDTO | null>>(
      `/trust_accounts/${trustAccountId}/instructions/payouts/beneficiaries/${partyId}/account`
    )
};
